export const WAITING_SCREEN = 'waiting';
export const REACHING_LIMIT_SCREEN = 'reaching_limit';
export const UPGRADE_LIMIT_SCREEN = 'upgrade_limit';
export const LOW_RISK_UPGRADE_LIMIT_SCREEN = 'low_risk_upgrade_limit';
